import React, { useRef, useEffect } from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { AuthProvider } from "./context/AuthContext"
import { ToastContainer, toast } from "react-toastify"
import useAuthAxios from "./hooks/useAuthAxios"
import authService from "./services/auth"

// Import Bootstrap and Font Awesome
import "bootstrap/dist/css/bootstrap.min.css"
import "@fortawesome/fontawesome-free/css/all.min.css"
import "react-toastify/dist/ReactToastify.css"
import "./styles/theme.css" // Import after Bootstrap to override its styles

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <React.StrictMode>
    <Wrapper>
      <App />
    </Wrapper>
  </React.StrictMode>
)

function Wrapper(props) {
  const toastRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (toastRef.current && !toastRef.current.contains(event.target)) {
        toast.dismiss() // Dismiss all active toasts
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const authAxios = useAuthAxios()
  authService(authAxios)

  return (
    <>
      <div ref={toastRef}>
        <ToastContainer position={"top-center"} closeOnClick={false} autoClose={false} />
      </div>
      <AuthProvider>{props.children}</AuthProvider>
    </>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
